/**
 * User Profile service - Batch lookup of nickname/avatar by userId
 * Calls user-service directly (not trip-service) — see specs/006-/research.md
 * for why this is not proxied through trip-service.
 */

import { apiGet } from './apiClient';
import type { UserProfile, UserProfileListResponse } from '../types/userProfile';

/**
 * Fetch profiles for the given user ids. Ids that don't exist (or belong to
 * deleted accounts) are simply omitted from the result — callers must not
 * assume the returned array length matches the input.
 */
export async function getUserProfiles(userIds: number[]): Promise<UserProfile[]> {
  if (userIds.length === 0) {
    return [];
  }

  const uniqueIds = Array.from(new Set(userIds));
  const response = await apiGet<UserProfileListResponse>(`/user/profiles?ids=${uniqueIds.join(',')}`);

  if (response.exitCode !== 1) {
    throw new Error(response.message || '取得使用者資料失敗');
  }

  return response.data;
}

export const userProfileService = {
  getProfiles: getUserProfiles,
};
